(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  /*
    Product carousel for .featured-carousel (rendered whenever this
    Featured collection instance has at least one product — always on
    mobile per the CSS in featured-collection.liquid, and also on
    desktop unless a merchant explicitly chose "Grille"). This same
    function initializes every Featured Collection instance on the
    page identically — see initAllFeaturedCarousels below, one call to
    initFeaturedCarousel(root) per .featured-carousel element found,
    each with its own independent closure (its own productIndex,
    productTimer, pendingSnapBack) so multiple instances never share or
    interfere with each other's state.

    One product visible at a time, one image per product
    (product.featured_image — no per-product photo cycling). Combined
    animation, exactly as asked: real horizontal movement
    (.featured-carousel__track is a flex row translated by
    translate3d(calc(-100% * index)), so each new product visibly
    enters from the right while the current one exits left) PLUS an
    opacity + light scale transition on the slide itself (JS toggles
    .is-active on the outgoing/incoming slide in the very same tick as
    the track's transform, so the entering product fades 0→1 and scales
    0.98→1 while sliding in, and the outgoing one fades out while
    sliding away) — same technique, and the same infinite-loop seam (a
    clone of the first product appended to the track) as the
    testimonials carousel in sections/multirow.liquid. Advancing fires
    every 2000ms via a single recurring timer (productTimer below — the
    only timer this carousel ever runs); the CSS transition on
    transform/opacity/scale (600ms, within the 500-700ms asked for) is
    what actually animates the move.

    What was specifically audited here and found already correct (no
    blocking issue found, listed so it's easy to re-check):
    - No competing script anywhere in assets/*.js touches
      .featured-carousel or anything inside it (grepped) — nothing else
      in the theme can override this behaviour.
    - Re-initializing (initFeaturedCarousel called again for the same
      root) always calls root.__featuredCarousel.stop() FIRST, which
      clears the pending timer, any pending snap-back, and removes the
      visibilitychange listener before any new one is created — a
      re-render (shopify:section:load) can never leave two timers or
      two listeners running for the same carousel.
    - shopify:section:load's event.target is the specific re-rendered
      section root; initAllFeaturedCarousels(event.target) re-scopes
      the query to it, so editing this section in the Theme Editor
      re-initializes its own carousel correctly without touching any
      other instance on the page.
    - visibilitychange only ever cancels the pending timer while hidden
      and restarts a fresh one on return (via resync() + a new
      scheduleProductTick()) — it can never leave the timer permanently
      stopped, and resync() forces the track back in sync with the
      logical index with no transition (also instantly settling the
      slide's own opacity/scale to its resting state), so a tab
      backgrounded mid-move can't come back stuck half-way between two
      slides or at a partial opacity.
    - translate3d(calc(-100% * index)) is always an exact multiple of
      100% — never a pixel/offsetWidth-based value — so nothing here
      can accumulate rounding error across many cycles.
    - The boot sequence explicitly covers both orderings of script vs.
      DOM readiness (readyState === 'loading' → wait for
      DOMContentLoaded once; otherwise boot immediately) rather than
      assuming one, so a Theme Editor context where the DOM is already
      parsed by the time this runs still boots on the very first tick.

    Diagnostic note (root-caused a report of "no autoplay, only arrows
    and a manual 1/2/3 counter" in the Theme Editor): that description
    matches Shopify's OWN stock <slider-component> (its
    .slider-buttons prev/next arrows and .slider-counter "current /
    total" — both defined only in the legacy-grid branch below, never
    in .featured-carousel) — a manually-operated slider with no
    autoplay of any kind, by design. It does not match anything this
    carousel renders. Confirmed by inspecting the live theme's actual
    current file content (surfaced via the shopify[bot] GitHub sync):
    it contained zero occurrences of "featured-carousel", "is_carousel"
    or any of this JS — literally the original, pre-carousel section,
    never updated by a `shopify theme push`. The fix for that is
    deploying this branch's current sections/featured-collection.liquid
    to the live theme (see the push command given after this change),
    not a JS change — the logic above was already sound before this
    edit; the boot-sequence rewrite here only makes that explicit and
    matches the exact requested shape, it does not fix a functional
    bug that existed in the code actually on this branch.

    Bidirectional swipe (added on top of the above, autoplay untouched):
    the track now has a clone at BOTH ends — a tail clone of the first
    product (already existed, for the forward loop) and a new head
    clone of the last product (see the Liquid above), so productIndex
    starts at 1 instead of 0 whenever a head clone exists. Forward and
    backward advances share one moveTrack(direction) helper that both
    autoplay's advanceProduct() and manual swipes call, so there is
    exactly one place that moves the track and checks for a clone
    landing — no duplicated, potentially-diverging logic between the
    two. advanceProduct() keeps its original guard/behaviour untouched
    (skip-and-reschedule if a loop-seam snap-back is still pending) so
    autoplay's already-verified 2000ms cadence cannot regress. A manual
    swipe instead resolves any pending snap-back immediately (a same-
    tick, no-transition bookkeeping reset — never dropped, never
    delayed) so a user's gesture is never silently ignored.

    Tap vs. swipe vs. page-scroll, on one pointerdown/pointermove/
    pointerup/pointercancel state machine (Pointer Events cover touch
    AND mouse identically, so desktop mouse-drag works the same way for
    free): a pointerdown just arms tracking, touching nothing yet — a
    plain tap therefore never pauses autoplay or touches the track, and
    its native click reaches the slide's product link completely
    normally. Only once movement exceeds a small 6px
    direction-lock threshold does the gesture get classified as
    horizontal (swipe candidate) or vertical (page scroll, left
    entirely to the browser via the existing touch-action: pan-y). Only
    a horizontal drag calls preventDefault(), pauses autoplay, and
    starts visually following the finger (clamped to +-1 slide). On
    release, a drag past a 40px threshold advances/reverses exactly one
    product with the normal animated transition; short of that, it
    settles back on the current product. Either way autoplay restarts
    cleanly via the same scheduleProductTick() the rest of the code
    already uses — never a second competing timer. A `click` listener
    in the CAPTURE phase on the track suppresses exactly one synthetic
    click after any real drag (regardless of whether it crossed the
    advance threshold), which is what stops a swipe from ever
    accidentally opening the product page.
  */
  function initFeaturedCarousel(root) {
    var viewport = root.querySelector(':scope > .featured-carousel__viewport');
    var track = viewport && viewport.querySelector(':scope > .featured-carousel__track');
    if (root.__featuredCarousel) {
      root.__featuredCarousel.stop();
      root.__featuredCarousel = null;
    }
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    var hasHeadClone = slides.length > 0 && slides[0].hasAttribute('data-clone');
    var hasTailClone = slides.length > 0 && slides[slides.length - 1].hasAttribute('data-clone');
    var realCount = slides.length - (hasHeadClone ? 1 : 0) - (hasTailClone ? 1 : 0);
    if (realCount < 1) return;

    // -1 (never equal to a real productIndex) when the corresponding
    // clone doesn't exist (single-product collections render neither).
    var firstRealIndex = hasHeadClone ? 1 : 0;
    var lastRealIndex = slides.length - 1 - (hasTailClone ? 1 : 0);
    var headCloneIndex = hasHeadClone ? 0 : -1;
    var tailCloneIndex = hasTailClone ? slides.length - 1 : -1;

    var productIndex = firstRealIndex;
    var productTimer = null;
    var pendingSnapBack = null;

    function setTrackPosition(i, animate) {
      track.style.transition = animate ? '' : 'none';
      // Exact multiples of 100% only — see note above.
      track.style.transform = 'translate3d(calc(-100% * ' + i + '), 0, 0)';
    }

    function cancelPendingSnapBack() {
      if (!pendingSnapBack) return;
      track.removeEventListener('transitionend', pendingSnapBack.onTransitionEnd);
      window.clearTimeout(pendingSnapBack.timeoutId);
      pendingSnapBack = null;
    }

    function cancelProductTimer() {
      if (productTimer) {
        window.clearTimeout(productTimer);
        productTimer = null;
      }
    }

    function scheduleProductTick() {
      cancelProductTimer();
      // A single product: nothing to advance to, no timer needed —
      // it just stays put.
      if (realCount < 2) return;
      productTimer = window.setTimeout(advanceProduct, 2000);
    }

    // Schedules the invisible loop-seam reset once the track has
    // visually landed on a clone (pixel-identical to the real slide it
    // duplicates, already carrying .is-active from moveTrack below).
    // Shared by both the forward (tail clone) and backward (head
    // clone) loop seams — same technique, opposite target index.
    function scheduleSnapBack(targetIndex) {
      var snapBack = function () {
        cancelPendingSnapBack();
        slides[productIndex].classList.remove('is-active');
        productIndex = targetIndex;
        setTrackPosition(productIndex, false);
        slides[productIndex].classList.add('is-active');
        // Pure reflow trigger (standard trick) — value discarded,
        // never used in a calculation. Applies the "no transition"
        // jump before the next tick/gesture re-enables it.
        void track.offsetWidth;
      };
      var onTransitionEnd = function (event) {
        if (event.target === track && event.propertyName === 'transform') snapBack();
      };
      track.addEventListener('transitionend', onTransitionEnd);
      pendingSnapBack = {
        run: snapBack,
        onTransitionEnd: onTransitionEnd,
        // Safety net: prefers-reduced-motion disables the CSS
        // transition entirely, so transitionend never fires there.
        timeoutId: window.setTimeout(snapBack, 700),
      };
    }

    // Moves the track exactly one product in `direction` (+1 forward,
    // -1 backward) and arms the matching loop-seam snap-back if the new
    // position landed on a clone. The only place that touches
    // productIndex/the track's transform for a one-product move —
    // advanceProduct() (autoplay) and manualAdvance() (swipe) both call
    // this, so forward and backward always behave identically.
    function moveTrack(direction) {
      var outgoingSlide = slides[productIndex];
      productIndex += direction;
      var incomingSlide = slides[productIndex];
      // Both the track's horizontal move AND the per-slide opacity/
      // scale are triggered together, in this same tick — the entering
      // slide fades in (0→1) and scales up (0.98→1) as it slides in,
      // and the outgoing one fades out as it slides away — regardless
      // of direction.
      setTrackPosition(productIndex, true);
      if (outgoingSlide) outgoingSlide.classList.remove('is-active');
      if (incomingSlide) incomingSlide.classList.add('is-active');

      if (productIndex === tailCloneIndex) {
        scheduleSnapBack(firstRealIndex);
      } else if (productIndex === headCloneIndex) {
        scheduleSnapBack(lastRealIndex);
      }
    }

    function advanceProduct() {
      if (pendingSnapBack) {
        // Extremely rare: the browser hasn't finished cleaning up the
        // previous loop seam yet (only possible under heavy main-thread
        // jank, since the snap-back normally completes well within the
        // 2000ms before this fires again). Don't advance past the
        // clone a second time — just keep the regular cadence ticking;
        // the very next tick will see the by-then-reset productIndex
        // and behave normally.
        scheduleProductTick();
        return;
      }

      // scheduleProductTick() is called unconditionally, right here,
      // every time — never inside the snap-back. That keeps the 2000ms
      // cadence perfectly regular forever: the loop seam is purely an
      // invisible bookkeeping reset that happens to also occur within
      // this same window, it never delays or advances the schedule.
      moveTrack(1);
      scheduleProductTick();
    }

    // Manual one-product move driven by a user swipe (direction: +1
    // next, -1 previous). Unlike advanceProduct(), a pending snap-back
    // is resolved immediately rather than skipped — it's a same-tick,
    // no-transition bookkeeping reset, so doing it right away is always
    // safe, and it means a user's gesture is never silently dropped.
    function manualAdvance(direction) {
      if (realCount < 2) return;
      if (pendingSnapBack) pendingSnapBack.run();
      cancelProductTimer();
      moveTrack(direction);
      scheduleProductTick();
    }

    // Instantly re-aligns the track and the active slide's opacity/
    // scale with the current logical state, no transition — used
    // after the tab was backgrounded, where setTimeout and CSS
    // transitions can be throttled or paused unpredictably by the
    // browser.
    function resync() {
      cancelPendingSnapBack();
      cancelProductTimer();
      if (productIndex === tailCloneIndex) {
        productIndex = firstRealIndex;
      } else if (productIndex === headCloneIndex) {
        productIndex = lastRealIndex;
      } else if (productIndex < 0 || productIndex >= slides.length) {
        productIndex = firstRealIndex;
      }
      setTrackPosition(productIndex, false);
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === productIndex);
      });
      void track.offsetWidth;
    }

    function handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        cancelProductTimer();
      } else {
        resync();
        scheduleProductTick();
      }
    }

    // --- Bidirectional swipe -------------------------------------------
    var SWIPE_THRESHOLD = 40; // px -- a tap stays far under this; a real drag clears it easily.
    var DIRECTION_LOCK_THRESHOLD = 6; // px of initial movement before deciding horizontal vs. vertical.
    var dragState = null;
    var suppressNextClick = false;

    function endDrag(advanced) {
      track.classList.remove('is-dragging');
      if (!advanced) {
        // Below threshold or cancelled: settle back on the current
        // product with the normal animated transition (no jump) and
        // restart autoplay — manualAdvance() already does the
        // equivalent when the swipe does clear the threshold.
        setTrackPosition(productIndex, true);
        scheduleProductTick();
      }
    }

    function onPointerDown(event) {
      if (event.isPrimary === false || realCount < 2) return;
      dragState = { pointerId: event.pointerId, startX: event.clientX, startY: event.clientY, horizontal: null, dragging: false };
    }

    function onPointerMove(event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      var dx = event.clientX - dragState.startX;
      var dy = event.clientY - dragState.startY;

      if (dragState.horizontal === null) {
        if (Math.abs(dx) > DIRECTION_LOCK_THRESHOLD || Math.abs(dy) > DIRECTION_LOCK_THRESHOLD) {
          dragState.horizontal = Math.abs(dx) > Math.abs(dy);
        }
      }

      if (!dragState.horizontal) return; // still undecided, or a vertical scroll -- leave it to the browser entirely.

      // A genuine horizontal drag: take over from autoplay and any
      // native scroll/click, and let the track visually follow the
      // finger for immediate feedback — clamped so it can never reveal
      // more than one neighbouring slide, whatever the drag distance.
      event.preventDefault();
      if (!dragState.dragging) {
        dragState.dragging = true;
        cancelProductTimer();
        cancelPendingSnapBack();
        track.classList.add('is-dragging');
        track.style.transition = 'none';
      }
      var viewportWidth = viewport.getBoundingClientRect().width || 1;
      var dragFraction = Math.max(-1, Math.min(1, dx / viewportWidth));
      track.style.transform = 'translate3d(calc(-100% * ' + productIndex + ' + ' + (dragFraction * 100) + '%), 0, 0)';
    }

    function onPointerUp(event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      var dx = event.clientX - dragState.startX;
      var wasDragging = dragState.dragging;
      dragState = null;

      if (!wasDragging) return; // plain tap: nothing was ever touched, let the native click open product.url.

      // A real drag happened: the browser's synthetic click that
      // follows pointerup must never navigate, whether or not this
      // particular drag cleared the advance threshold.
      suppressNextClick = true;

      if (Math.abs(dx) >= SWIPE_THRESHOLD) {
        manualAdvance(dx < 0 ? 1 : -1); // swipe left -> next, swipe right -> previous
        endDrag(true);
      } else {
        endDrag(false);
      }
    }

    function onPointerCancel(event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      var wasDragging = dragState.dragging;
      dragState = null;
      if (wasDragging) endDrag(false);
    }

    function onTrackClickCapture(event) {
      if (!suppressNextClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressNextClick = false;
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerCancel);
    track.addEventListener('click', onTrackClickCapture, true);

    setTrackPosition(productIndex, false);
    scheduleProductTick();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    root.__featuredCarousel = {
      stop: function () {
        cancelProductTimer();
        cancelPendingSnapBack();
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('pointermove', onPointerMove);
        track.removeEventListener('pointerup', onPointerUp);
        track.removeEventListener('pointercancel', onPointerCancel);
        track.removeEventListener('click', onTrackClickCapture, true);
      },
    };
  }

  function initAllFeaturedCarousels(root) {
    (root || document).querySelectorAll('.featured-carousel').forEach(initFeaturedCarousel);
  }

  // Robust boot: this script tag can load and execute either before or
  // after the DOM is ready, depending on how/when Shopify serves this
  // section's bundled assets (a normal storefront load vs. the Theme
  // Editor injecting/re-rendering a section into an already-parsed
  // page). Covering both orderings explicitly, rather than assuming
  // one, is what guarantees the very first autoplay tick always gets
  // armed regardless of context.
  function bootFeaturedCarousels() {
    initAllFeaturedCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFeaturedCarousels, { once: true });
  } else {
    // DOMContentLoaded already fired before this script ran (the exact
    // Theme Editor scenario above) — boot immediately instead of
    // waiting for an event that will never come again.
    bootFeaturedCarousels();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllFeaturedCarousels(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var carousel = event.target.querySelector && event.target.querySelector('.featured-carousel');
    if (carousel && carousel.__featuredCarousel) {
      carousel.__featuredCarousel.stop();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class EarlyAccessCrossSell extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
    }

    connectedCallback() {
      const modal = this.closest('modal-dialog');
      if (!modal) return;

      if (modal.hasAttribute('open')) {
        this.load();
        return;
      }

      this.modalObserver = new MutationObserver(() => {
        if (modal.hasAttribute('open')) this.load();
      });
      this.modalObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
    }

    load() {
      if (this.loaded) return;
      this.loaded = true;
      this.modalObserver?.disconnect();

      fetch(`${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('early-access-cross-sell');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  customElements.define('early-access-cross-sell', EarlyAccessCrossSell);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multirow"] && !Shopify.designMode) return;
  try {
    
  /*
    Fade carousel for .multirow__inner--carousel (rendered only when
    the section's "layout" setting isn't "grid" — see multirow.liquid).
    One real "look" photo visible at a time; every slide is stacked in
    the same grid cell (CSS) and advancing is purely a class toggle —
    the outgoing slide loses .is-active (fades to opacity: 0,
    visibility: hidden, pointer-events: none, inert), the incoming one
    gains it (fades to opacity: 1, visible, interactive) — driven by
    the CSS `transition: opacity` already on each slide, so this file
    never touches transform/position and there is no track to keep in
    sync with anything. Advances every 2000ms, native/no dependency.

    No clone slide, no snap-back: with no horizontal position to reset,
    the "last -> first" wrap is just index = (index + 1) % realCount —
    already exactly as invisible as every other transition.
  */
  function initMultirowCarousel(root) {
    var track = root.querySelector(':scope > .multirow__viewport > .multirow__track');
    if (root.__multirowCarousel) {
      root.__multirowCarousel.stop();
      root.__multirowCarousel = null;
    }
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    var realCount = slides.length;
    if (realCount < 2) return;

    var index = 0;
    var timer = null;

    function markCurrent(i) {
      slides.forEach(function (slide, slideIndex) {
        var isCurrent = slideIndex === i;
        slide.classList.toggle('is-active', isCurrent);
        slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
        // inert (on top of the CSS opacity/visibility/pointer-events
        // toggle) removes the non-active slides from the tab order and
        // the accessibility tree outright, not just visually — belt
        // and suspenders alongside aria-hidden, and it costs nothing
        // here since none of these rows currently render a focusable
        // button anyway.
        if (isCurrent) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    }

    function goToNext() {
      index = (index + 1) % realCount;
      markCurrent(index);
    }

    function start() {
      stop();
      timer = window.setInterval(goToNext, 2000);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    // Backgrounded tabs can throttle/pause setInterval unpredictably —
    // pausing while hidden and just re-arming a fresh 2000ms interval
    // on return is all a fade carousel needs (there is no transform
    // position to resync, unlike a translateX track).
    function handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        stop();
      } else {
        start();
      }
    }

    markCurrent(0);
    start();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    root.__multirowCarousel = {
      stop: function () {
        stop();
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      },
    };
  }

  function initAllMultirowCarousels(root) {
    (root || document).querySelectorAll('.multirow__inner--carousel').forEach(initMultirowCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllMultirowCarousels();
    });
  } else {
    initAllMultirowCarousels();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllMultirowCarousels(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var carousel = event.target.querySelector && event.target.querySelector('.multirow__inner--carousel');
    if (carousel && carousel.__multirowCarousel) {
      carousel.__multirowCarousel.stop();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
    function wait(ms) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, ms);
      });
    }

    class NewsletterPopupElement extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.contentEl = this.querySelector('.newsletter-popup__content');
        this.closeBtn = this.querySelector('[data-newsletter-close]');
        this.formWrapper = this.querySelector('[data-newsletter-form-wrapper]');
        this.statusEl = this.querySelector('[data-newsletter-status]');

        this.storageKey = 'ac:newsletter-popup:v1';
        this.sessionKey = 'ac:newsletter-popup:shown:v1';
        this.delay = parseInt(this.dataset.delayMs, 10) || 4000;
        this.reappearDays = parseFloat(this.dataset.reappearDays) || 7;
        // Translated in Liquid (sections.newsletter_popup.* in locales/).
        this.genericError = this.dataset.genericError || '';
        this.copyLabel = this.dataset.copyLabel || '';
        this.copiedLabel = this.dataset.copiedLabel || '';
        this.rewardEyebrow = this.dataset.rewardEyebrow || '';
        this.subscribedLabel = this.dataset.subscribedLabel || '';
        this.startingHandLabel = this.dataset.startingHandLabel || '';
        this.blackjackEnabled = this.dataset.blackjackEnabled === 'true';
        this.reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        this.subscribedThisSession = false;
        this.heroVideo = null;
        this.heroVideoWasPlaying = false;

        var sectionWrapper = this.closest('.shopify-section');
        this.dataset.section = sectionWrapper ? sectionWrapper.id.replace('shopify-section-', '') : '';
        // Match the same "move to <body>" safety already used by the
        // theme's own <modal-dialog> (assets/global.js) -- a
        // position:fixed popup can otherwise get clipped/mispositioned
        // if a future ancestor ever gains a transform/overflow rule.
        if (this.parentNode !== document.body) {
          document.body.appendChild(this);
        }

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.close(true));
        }
        // Keyboard, while open: Escape closes from anywhere, and Tab cycles
        // through the controls visible right now (the email form only
        // appears after a Blackjack choice, so the list is read on each
        // press rather than once at opening, as trapFocus() does).
        document.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'Escape' || event.key === 'Escape') {
            this.close(true);
            return;
          }
          if (event.key !== 'Tab') return;
          var focusables = Array.prototype.filter.call(
            this.contentEl.querySelectorAll(
              'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
            ),
            function (element) {
              return element.getClientRects().length > 0;
            }
          );
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          var inside = this.contentEl.contains(document.activeElement);
          if (event.shiftKey && (!inside || document.activeElement === first)) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && (!inside || document.activeElement === last)) {
            event.preventDefault();
            first.focus();
          }
        });
        this.addEventListener('click', (event) => {
          if (event.target === this) this.close(true);
        });
        // No fetch/AJAX interception of the submit: it must reach
        // Shopify as a real, native form POST (see handlePostSubmitState()
        // below for why -- an intercepted fetch() to /contact was
        // unreliable against the live store and could report failure
        // even when Shopify had actually processed the signup). This
        // listener only disables the button so a slow connection can't
        // be double-submitted; it never calls preventDefault().
        this.addEventListener('submit', (event) => {
          var form = event.target.closest ? event.target.closest('form') : null;
          if (!form || !this.formWrapper || !this.formWrapper.contains(form)) return;
          var submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.disabled = true;
        });
        this.addEventListener('click', (event) => {
          var copyBtn = event.target.closest && event.target.closest('[data-newsletter-copy]');
          if (copyBtn) this.handleCopy(copyBtn);
        });

        if (this.blackjackEnabled) {
          this.initGame();
        }

        // A native form POST redirects/reloads back to this same page --
        // if Shopify just confirmed (or rejected) the signup we were
        // mid-submitting, reopen immediately and show that outcome,
        // bypassing the normal auto-show suppression (this is a direct
        // continuation of the visitor's own action, not an unsolicited
        // popup).
        var postSubmitHandled = this.handlePostSubmitState();

        if (window.Shopify && window.Shopify.designMode) {
          this.setupEditorPreview();
          return;
        }
        if (!postSubmitHandled) {
          this.setupAutoShow();
        }
      }

      setupEditorPreview() {
        var self = this;
        document.addEventListener('shopify:section:select', function (event) {
          if (event.detail && event.detail.sectionId === self.dataset.section) self.open();
        });
        document.addEventListener('shopify:section:deselect', function (event) {
          if (event.detail && event.detail.sectionId === self.dataset.section) self.close(false);
        });
      }

      setupAutoShow() {
        if (!this.shouldAutoShow()) return;
        var self = this;
        var triggered = false;
        var timerId;
        function trigger() {
          if (triggered) return;
          triggered = true;
          window.removeEventListener('scroll', onScroll);
          window.clearTimeout(timerId);
          openWhenCookieBannerClosed();
        }
        // Shopify's cookie banner (z-index 2000000) covers the popup on
        // mobile: wait until the visitor accepts or refuses, then open.
        function openWhenCookieBannerClosed() {
          var banner = document.getElementById('shopify-pc__banner');
          if (banner && window.getComputedStyle(banner).display !== 'none') {
            window.setTimeout(openWhenCookieBannerClosed, 1000);
            return;
          }
          self.markShownThisSession();
          self.open();
        }
        function onScroll() {
          var scrollable = document.documentElement.scrollHeight - window.innerHeight;
          if (scrollable <= 0) return;
          if (window.scrollY / scrollable >= 0.3) trigger();
        }
        timerId = window.setTimeout(trigger, this.delay);
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      shouldAutoShow() {
        if (this.readSession()) return false;
        var state = this.readState();
        if (!state) return true;
        if (state.subscribed) return false;
        if (state.dismissedAt) {
          var elapsedDays = (Date.now() - state.dismissedAt) / 86400000;
          if (elapsedDays < this.reappearDays) return false;
        }
        return true;
      }

      readSession() {
        try {
          return window.sessionStorage.getItem(this.sessionKey) === '1';
        } catch (e) {
          return false;
        }
      }

      markShownThisSession() {
        try {
          window.sessionStorage.setItem(this.sessionKey, '1');
        } catch (e) {
          /* localStorage/sessionStorage unavailable -- never block the popup for this */
        }
      }

      readState() {
        try {
          var raw = window.localStorage.getItem(this.storageKey);
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      }

      writeState(patch) {
        try {
          var current = this.readState() || {};
          for (var key in patch) current[key] = patch[key];
          window.localStorage.setItem(this.storageKey, JSON.stringify(current));
        } catch (e) {
          /* localStorage unavailable -- state simply won't persist */
        }
      }

      // -- Hero video pause/resume ------------------------------------
      // Identifies the homepage hero video via the exact selector
      // sections/video.liquid's own autoplay script (playAutoplayVideos)
      // already uses for itself: [data-autoplay-video] video. Reusing
      // that selector, rather than a blind
      // document.querySelectorAll('video'), means this only ever
      // touches the one autoplaying hero video, never a product video,
      // a modal-video popup elsewhere, etc. On pages with no hero video
      // this is simply a no-op.

      findHeroVideo() {
        return document.querySelector('[data-autoplay-video] video');
      }

      pauseHeroVideo() {
        var video = this.findHeroVideo();
        this.heroVideo = video || null;
        if (!video) return;
        this.heroVideoWasPlaying = !video.paused;
        try {
          video.pause();
        } catch (e) {
          /* never block the popup opening over a pause() failure */
        }
      }

      resumeHeroVideo() {
        var video = this.heroVideo;
        this.heroVideo = null;
        // Only resume a video that was actually playing when we paused
        // it -- if the merchant/visitor had already paused it, closing
        // the popup should not start it back up on its own.
        if (!video || !this.heroVideoWasPlaying) return;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            /* a browser can reject an autoplay-resume Promise -- silent, same pattern as sections/video.liquid's own playAutoplayVideos() */
          });
        }
      }

      open() {
        if (this.hasAttribute('open')) return;
        this.pauseHeroVideo();
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        if (typeof trapFocus === 'function') trapFocus(this, this.contentEl);
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      }

      close(recordDismissal) {
        if (!this.hasAttribute('open')) return;
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        this.resumeHeroVideo();
        if (recordDismissal && !this.subscribedThisSession) {
          this.writeState({ dismissedAt: Date.now() });
        }
      }

      setStatus(message) {
        if (this.statusEl) this.statusEl.textContent = message || '';
      }

      // Called once per connectedCallback, right after initGame() has
      // restored any prior Blackjack choice from localStorage (so
      // resultEl/emailEl are already unhidden and currentCode/
      // currentRewardLabel are already set when this runs). A native
      // form POST is a real page reload: Shopify processes the
      // signup server-side and this element is simply rebuilt fresh on
      // the response page, with `form.posted_successfully?`/
      // `form.errors` already resolved by Liquid -- reflected here only
      // as the presence of [data-newsletter-success] (success) or a
      // visible [data-newsletter-error] (rejected: invalid address,
      // already subscribed, etc.), never inferred from the fetch
      // succeeding or failing. Returns true if it reopened the popup
      // for this reason.
      handlePostSubmitState() {
        if (!this.formWrapper) return false;
        var success = this.formWrapper.querySelector('[data-newsletter-success]');
        var error = this.formWrapper.querySelector('[data-newsletter-error]:not([hidden])');
        if (!success && !error) return false;

        if (success) {
          this.writeState({ subscribed: true });
          this.subscribedThisSession = true;
          if (this.blackjackEnabled) this.fillRewardPanel(success);
        }

        this.markShownThisSession();
        this.open();

        if (success) {
          success.setAttribute('tabindex', '-1');
          success.focus();
          this.setStatus(this.subscribedLabel);
        } else {
          error.focus && error.focus();
          this.setStatus(error.textContent.trim() || this.genericError);
        }
        return true;
      }

      // Liquid renders the success fragment generically (it can't know
      // which of the three outcomes a visitor drew -- that only ever
      // happens client-side), so the reward label/code are filled in
      // here from the outcome already decided (and persisted) at
      // STAND/HIT time.
      fillRewardPanel(successEl) {
        var labelEl = successEl.querySelector('[data-bj-reward-label]');
        var codeEl = successEl.querySelector('[data-bj-reward-code]');
        var copyBtn = successEl.querySelector('[data-newsletter-copy]');
        var label = this.currentRewardLabel || '';
        var code = this.currentCode || '';
        if (labelEl) labelEl.textContent = label;
        if (codeEl) codeEl.textContent = code;
        if (copyBtn) copyBtn.setAttribute('data-newsletter-copy', code);
        // The "RÉCUPÉREZ VOTRE RÉDUCTION" prompt (bj_email_unlock_text) sits
        // above the form wrapper (not inside it), so it survives the
        // innerHTML swap -- hide it once the reward panel it was
        // prompting for is showing.
        if (this.emailUnlockEl) this.emailUnlockEl.hidden = true;
      }

      handleCopy(button) {
        var code = button.getAttribute('data-newsletter-copy');
        if (!code) return;
        var self = this;

        function announceCopied() {
          var original = button.textContent;
          button.textContent = self.copiedLabel;
          button.disabled = true;
          window.setTimeout(function () {
            button.textContent = original;
            button.disabled = false;
          }, 1500);
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(announceCopied).catch(function () {
            /* clipboard permission denied -- copy is a nice-to-have, never block the flow */
          });
          return;
        }

        try {
          var textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
          announceCopied();
        } catch (e) {
          /* no clipboard support available -- silently skip, code is still visible on screen */
        }
      }

      // -- Blackjack game -----------------------------------------------
      // Deck: only the exact cards the mechanic ever uses. Suit is
      // purely cosmetic -- only rank/value feeds the promotional
      // outcome, and that outcome is decided by the single configured
      // win-probability setting, never real blackjack odds.

      initGame() {
        this.config = this.readGameConfig();
        this.cardsEl = this.querySelector('[data-bj-cards]');
        this.headlineEl = this.querySelector('[data-bj-headline]');
        this.totalEl = this.querySelector('[data-bj-total]');
        this.totalLabelEl = this.querySelector('[data-bj-total-label]');
        this.choicePromptEl = this.querySelector('[data-bj-choice-prompt]');
        this.subheadingEl = this.querySelector('[data-bj-subheading]');
        this.actionsEl = this.querySelector('[data-bj-actions]');
        this.resultEl = this.querySelector('[data-bj-result]');
        this.resultHeadlineEl = this.querySelector('[data-bj-result-headline]');
        this.resultRewardEl = this.querySelector('[data-bj-result-reward]');
        this.resultConsolationEl = this.querySelector('[data-bj-result-consolation]');
        this.emailBlockEl = this.querySelector('[data-bj-email]');
        this.emailUnlockEl = this.querySelector('[data-bj-email-unlock]');
        this.standBtn = this.querySelector('[data-bj-stand]');
        this.hitBtn = this.querySelector('[data-bj-hit]');
        this.choiceLocked = false;
        this.currentCode = '';
        this.currentRewardLabel = '';

        if (this.standBtn) this.standBtn.addEventListener('click', () => this.chooseStand());
        if (this.hitBtn) this.hitBtn.addEventListener('click', () => this.chooseHit());

        var state = this.readState() || {};
        if (state.choice) {
          this.choiceLocked = true;
          this.restoreChoice(state);
        } else {
          this.renderIntro();
        }
      }

      readGameConfig() {
        var scriptEl = this.querySelector('[data-bj-config]');
        if (!scriptEl) return {};
        try {
          return JSON.parse(scriptEl.textContent) || {};
        } catch (e) {
          return {};
        }
      }

      // Reduced-motion-aware delay: every animation/suspense wait in the
      // game runs through this, so prefers-reduced-motion collapses the
      // whole sequence to (near-)instant without a separate code path.
      d(ms) {
        return this.reducedMotion ? 0 : ms;
      }

      suitSymbol(suit) {
        return { spades: '♠', hearts: '♥', diamonds: '♦', clubs: '♣' }[suit] || '';
      }

      isRedSuit(suit) {
        return suit === 'hearts' || suit === 'diamonds';
      }

      isFaceRank(rank) {
        return rank === 'J' || rank === 'Q' || rank === 'K';
      }

      // Editorial card face: a small index top-left (rank over suit) and
      // its mirrored twin bottom-right, plus the Anticonformiste heart
      // centred -- a faint watermark on number cards, the main graphic
      // on face cards (stands in for a traditional court-card
      // illustration). Missing/empty logo markup just leaves the centre
      // blank; the corner indices alone still read as a real card.
      cardFaceHtml(card) {
        var index = card.rank + '<br>' + this.suitSymbol(card.suit);
        var logoClass = 'bj-card__logo' + (this.isFaceRank(card.rank) ? ' bj-card__logo--face' : '');
        var logoUrl = this.config.cardLogoUrl || '';
        var logo = logoUrl
          ? '<span class="bj-card__logo-mask" style="-webkit-mask-image:url(\'' +
            logoUrl +
            "');mask-image:url('" +
            logoUrl +
            "')\"></span>"
          : '';
        return (
          '<span class="bj-card__index bj-card__index--top">' + index + '</span>' +
          '<span class="' + logoClass + '" aria-hidden="true">' + logo + '</span>' +
          '<span class="bj-card__index bj-card__index--bottom">' + index + '</span>'
        );
      }

      // Plain face-up card -- used for the first two cards, and for
      // every card when restoring a prior choice from storage (no
      // animation replay on restore).
      dealCard(card, animate) {
        if (!this.cardsEl) return null;
        var el = document.createElement('div');
        el.className = 'bj-card' + (this.isRedSuit(card.suit) ? ' bj-card--red' : '') + (animate ? ' bj-card--dealt' : '');
        el.setAttribute('aria-hidden', 'true');
        el.innerHTML = this.cardFaceHtml(card);
        this.cardsEl.appendChild(el);
        return el;
      }

      // Face-down card with the Anticonformiste heart on a black back,
      // used only for HIT's third card while it's actually being played
      // (never on restore): arrives back-up, then flips in 3D to reveal
      // the face -- see chooseHit() for the timing.
      dealFlipCard(card) {
        if (!this.cardsEl) return null;
        var wrap = document.createElement('div');
        wrap.className = 'bj-card-flip bj-card-flip--dealt';
        wrap.setAttribute('aria-hidden', 'true');

        var inner = document.createElement('div');
        inner.className = 'bj-card-flip__inner';

        var back = document.createElement('div');
        back.className = 'bj-card-flip__face bj-card-flip__face--back';
        var backLogoUrl = this.config.cardLogoUrl || '';
        var backLogo = backLogoUrl ? '<img src="' + backLogoUrl + '" alt="" loading="lazy">' : '';
        back.innerHTML = '<span class="bj-card-back__mark">' + backLogo + '</span>';

        var front = document.createElement('div');
        front.className = 'bj-card-flip__face bj-card-flip__face--front bj-card' + (this.isRedSuit(card.suit) ? ' bj-card--red' : '');
        front.innerHTML = this.cardFaceHtml(card);

        inner.appendChild(back);
        inner.appendChild(front);
        wrap.appendChild(inner);
        this.cardsEl.appendChild(wrap);
        return wrap;
      }

      // Fade+rise an element in (removing `hidden` first, then waiting a
      // frame so the browser actually paints the "before" state --
      // otherwise the opacity/transform change can get batched into the
      // same frame as unhiding and never visibly transition).
      reveal(el) {
        if (!el) return;
        // The "Votre main" caption always appears with the total.
        if (el === this.totalEl) this.reveal(this.totalLabelEl);
        el.hidden = false;
        if (this.reducedMotion) {
          el.classList.add('bj-reveal--in');
          return;
        }
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.classList.add('bj-reveal--in');
          });
        });
      }

      async renderIntro() {
        this.reveal(this.headlineEl);
        if (this.reducedMotion) {
          this.dealCard({ rank: '7', suit: 'spades' }, false);
          this.dealCard({ rank: '5', suit: 'hearts' }, false);
          this.totalEl && (this.totalEl.textContent = '12');
          this.reveal(this.totalEl);
          this.reveal(this.subheadingEl);
          this.reveal(this.actionsEl);
          this.setStatus(this.startingHandLabel);
          return;
        }
        // Sequenced, not all at once: title -> card 7 -> card 5 -> total
        // -> question -> actions. A dealer-style deal: each card arrives
        // from the top-right (see .bj-card--dealt), ~150ms apart.
        await wait(150);
        this.dealCard({ rank: '7', suit: 'spades' }, true);
        await wait(150);
        this.dealCard({ rank: '5', suit: 'hearts' }, true);
        await wait(450); // let the second card settle before the total appears
        this.totalEl && (this.totalEl.textContent = '12');
        this.reveal(this.totalEl);
        await wait(200);
        this.reveal(this.subheadingEl);
        await wait(200);
        this.reveal(this.actionsEl);
        this.setStatus(this.startingHandLabel);
      }

      restoreChoice(state) {
        this.reveal(this.headlineEl);
        this.dealCard({ rank: '7', suit: 'spades' }, false);
        this.dealCard({ rank: '5', suit: 'hearts' }, false);
        if (state.choice === 'hit' && state.card3) {
          this.dealCard(state.card3, false);
          if (this.totalEl) this.totalEl.textContent = state.outcome === 'win' ? '21' : '22';
        } else if (this.totalEl) {
          this.totalEl.textContent = '12';
        }
        this.reveal(this.totalEl);
        if (this.choicePromptEl) this.choicePromptEl.hidden = true;
        this.showResult(state.outcome, 'instant');
        if (state.subscribed) this.renderClaimedReward();
      }

      async chooseStand() {
        if (this.choiceLocked) return;
        this.choiceLocked = true;
        if (this.standBtn) this.standBtn.disabled = true;
        if (this.hitBtn) this.hitBtn.disabled = true;
        this.writeState({ choice: 'stand', outcome: 'stand', card3: null });
        // Deliberately the calm path: the buttons fade out, then (once
        // they're gone) the result fades in as one simple, quiet step --
        // no cards, no suspense. Contrast with HIT's flip/reveal below
        // is the point.
        this.hideChoicePrompt();
        await wait(this.d(250));
        await this.showResult('stand', 'stand');
      }

      async chooseHit() {
        if (this.choiceLocked) return;
        this.choiceLocked = true;
        if (this.standBtn) this.standBtn.disabled = true;
        if (this.hitBtn) this.hitBtn.disabled = true;

        // The draw happens once, right here, and is persisted before any
        // animation runs -- a refresh at any point during the sequence
        // below always restores this exact same outcome, never a new
        // roll. Everything from here down only *delays the reveal* of a
        // result that already exists.
        var winProbability = parseFloat(this.config.winProbability);
        if (isNaN(winProbability)) winProbability = 35;
        winProbability = Math.max(0, Math.min(100, winProbability));
        var didWin = Math.random() * 100 < winProbability;
        var outcome = didWin ? 'win' : 'bust';
        var card3 = didWin ? { rank: '9', suit: 'clubs' } : this.randomBustCard();
        this.writeState({ choice: 'hit', outcome: outcome, card3: card3 });

        // 1. Card arrives face-down (Anticonformiste back visible).
        var wrap = this.dealFlipCard(card3);
        await wait(this.d(400));
        // 2. A beat of suspense before anything else happens.
        await wait(this.d(300));
        // 3. The flip itself -- only past its midpoint does the real
        //    face become visible (backface-visibility handles that).
        if (wrap) wrap.classList.add('bj-card-flip--revealed');
        await wait(this.d(550));
        // 4. Only now does the score update.
        await this.updateTotal(didWin ? 21 : 22, outcome);
        await wait(this.d(200));
        // 5. Then, and only then, the result.
        this.hideChoicePrompt();
        await wait(this.d(150));
        await this.showResult(outcome, 'hit');
      }

      // Score change: a brief fade+lift swap of the digits (never an
      // abrupt text replacement), followed by an outcome-specific
      // flourish -- WIN gets a soft scale pulse plus a fine glow around
      // the card group, BUST gets a very small (~2px) shake. Never
      // confetti, never a colour flash.
      async updateTotal(value, outcome) {
        if (!this.totalEl) return;
        if (this.reducedMotion) {
          this.totalEl.textContent = String(value);
        } else {
          this.totalEl.classList.add('bj-total--swap');
          await wait(150);
          this.totalEl.textContent = String(value);
          void this.totalEl.offsetWidth; // force layout so removing the class transitions back in
          this.totalEl.classList.remove('bj-total--swap');
          await wait(150);
        }
        if (this.reducedMotion) return;
        if (outcome === 'win') {
          this.totalEl.classList.add('bj-total--pulse');
          if (this.cardsEl) this.cardsEl.classList.add('bj-cards--glow');
          await wait(400);
          this.totalEl.classList.remove('bj-total--pulse');
          if (this.cardsEl) this.cardsEl.classList.remove('bj-cards--glow');
        } else if (outcome === 'bust') {
          if (this.cardsEl) this.cardsEl.classList.add('bj-cards--shake');
          await wait(300);
          if (this.cardsEl) this.cardsEl.classList.remove('bj-cards--shake');
        }
      }

      randomBustCard() {
        var ranks = ['10', 'J', 'Q', 'K'];
        var suits = ['spades', 'hearts', 'diamonds', 'clubs'];
        return {
          rank: ranks[Math.floor(Math.random() * ranks.length)],
          suit: suits[Math.floor(Math.random() * suits.length)],
        };
      }

      hideChoicePrompt() {
        if (!this.choicePromptEl) return;
        var el = this.choicePromptEl;
        if (this.reducedMotion) {
          el.hidden = true;
          return;
        }
        el.classList.add('bj-fade-out');
        window.setTimeout(function () {
          el.hidden = true;
        }, 220);
      }

      // mode: 'hit' (full staggered reveal -- the suspense payoff),
      // 'stand' (calm, quick stagger), or 'instant' (restoring a prior
      // choice from storage -- no animation, no delay, ever).
      async showResult(outcome, mode) {
        var cfg = this.config;
        var headline, rewardLabel, code, consolation, showReward;
        if (outcome === 'win') {
          headline = cfg.winHeadline;
          rewardLabel = cfg.winRewardLabel;
          code = cfg.winCode;
          consolation = '';
          showReward = true;
        } else if (outcome === 'bust') {
          // Simplified BUST screen: no standalone "5% OFF" line before
          // the consolation copy -- the reward/code themselves are
          // unchanged, only shown after signup like the others.
          headline = cfg.bustHeadline;
          rewardLabel = cfg.bustRewardLabel;
          code = cfg.bustCode;
          consolation = cfg.bustConsolationText || '';
          showReward = false;
        } else {
          headline = cfg.standHeadline;
          rewardLabel = cfg.standRewardLabel;
          code = cfg.standCode;
          consolation = '';
          showReward = true;
        }
        this.currentCode = code || '';
        this.currentRewardLabel = rewardLabel || '';

        if (this.resultHeadlineEl) this.resultHeadlineEl.textContent = headline || '';
        if (this.resultRewardEl) {
          this.resultRewardEl.hidden = !showReward;
          this.resultRewardEl.textContent = showReward ? rewardLabel || '' : '';
        }
        if (this.resultConsolationEl) {
          this.resultConsolationEl.textContent = consolation;
          this.resultConsolationEl.hidden = !consolation;
        }
        if (this.emailUnlockEl) this.emailUnlockEl.textContent = cfg.emailUnlockText || '';
        if (this.resultEl) this.resultEl.hidden = false;

        var statusMessage = [headline, showReward ? rewardLabel : consolation].filter(Boolean).join(' ');

        if (mode === 'instant' || this.reducedMotion) {
          this.reveal(this.resultHeadlineEl);
          if (showReward) this.reveal(this.resultRewardEl);
          if (this.resultConsolationEl && !this.resultConsolationEl.hidden) this.reveal(this.resultConsolationEl);
          this.reveal(this.emailBlockEl);
          this.setStatus(statusMessage);
          return;
        }

        // Ordered, staggered reveal -- never everything at once: card
        // (already done by the caller) -> score (already done by the
        // caller) -> headline -> reward/consolation -> email form.
        var gap = mode === 'stand' ? 90 : 150;
        this.reveal(this.resultHeadlineEl);
        await wait(gap);
        if (showReward) {
          this.reveal(this.resultRewardEl);
          await wait(gap);
        } else if (this.resultConsolationEl && !this.resultConsolationEl.hidden) {
          this.reveal(this.resultConsolationEl);
          await wait(gap);
        }
        this.reveal(this.emailBlockEl);
        this.setStatus(statusMessage);
      }

      // Edge case: a returning visitor who already claimed their reward
      // in a previous visit (state.subscribed) but somehow sees the
      // popup again (e.g. manually re-triggered) -- Liquid has no
      // memory of that past POST, so the native form would render as
      // blank/unsubmitted again. Show the reward panel directly instead
      // of letting them submit a second time.
      renderClaimedReward() {
        if (!this.emailBlockEl) return;
        var label = this.escapeHtml(this.currentRewardLabel);
        var code = this.escapeHtml(this.currentCode);
        this.emailBlockEl.innerHTML =
          '<div class="newsletter-popup__success" data-newsletter-success tabindex="-1">' +
          '<p class="newsletter-popup__eyebrow editorial-eyebrow">' + this.escapeHtml(this.rewardEyebrow) + '</p>' +
          '<p class="bj-reward-panel__label">' + label + '</p>' +
          '<div class="newsletter-popup__code-row">' +
          '<span class="newsletter-popup__code">' + code + '</span>' +
          '<button type="button" class="newsletter-popup__copy" data-newsletter-copy="' + code + '">' + this.escapeHtml(this.copyLabel) + '</button>' +
          '</div></div>';
      }

      escapeHtml(value) {
        var div = document.createElement('div');
        div.textContent = value || '';
        return div.innerHTML;
      }
    }

    if (!customElements.get('newsletter-popup')) {
      customElements.define('newsletter-popup', NewsletterPopupElement);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  /*
    Real-browser autoplay fallback for the [data-autoplay-video] video
    only (rendered exclusively when "Lecture automatique" is ON — the
    deferred-media click-to-play path below is untouched and has no
    live <video> element for this selector to match, so this is fully
    inert when autoplay is OFF).

    The Liquid-level video_tag attributes (autoplay/loop/muted/
    playsinline/preload) are usually enough, but some browsers still
    require play() to be called from script once the media is actually
    ready, especially after a Theme Editor section reload. This calls
    play() defensively on load, on loadedmetadata/canplay, and again on
    shopify:section:load, and swallows a rejected play() Promise instead
    of letting it surface as a console error (a rejection here just
    means the browser wants to wait a beat — the visibilitychange retry
    below covers the common case of a backgrounded tab).
  */
  function playAutoplayVideos(root) {
    (root || document).querySelectorAll('[data-autoplay-video] video').forEach(function (video) {
      if (video.__autoplayBound) return;
      video.__autoplayBound = true;

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;

      var attemptPlay = function () {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            var onVisible = function () {
              if (document.visibilityState === 'visible') {
                document.removeEventListener('visibilitychange', onVisible);
                video.play().catch(function () {});
              }
            };
            document.addEventListener('visibilitychange', onVisible);
          });
        }
      };

      if (video.readyState >= 2) {
        attemptPlay();
      } else {
        video.addEventListener('loadedmetadata', attemptPlay, { once: true });
        video.addEventListener('canplay', attemptPlay, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      playAutoplayVideos();
    });
  } else {
    playAutoplayVideos();
  }

  document.addEventListener('shopify:section:load', function (event) {
    playAutoplayVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
